import { standard } from '@creditas-ui/themes'

export function getColorToken(token) {
  const [color, level] = token.split('.')
  return standard.colors?.[color]?.[level]
}
